// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4585":"9bf04c9c47900ebf","8711":"1101a3bac61304aa"}[chunkId] + ".js";
};